import sdkFactory from '@gravity-ui/sdk';
import type {GatewayError} from '@gravity-ui/sdk/build/models/common';

import type {ResponseType} from 'axios';

import {Header} from '~shared/constants';
import type {Schema} from '~shared/schema';

import {get} from '~ui/utils/lodash';
import {lang} from '~ui/constants/ui-lang';
import {i18n} from '~ui/components/WikiPage/i18n';

import toaster from '~ui/utils/toaster';

const sdkFactoryTemplate = (responseType?: ResponseType, timeout?: number) => {
    return sdkFactory<{root: typeof Schema}>({
        csrfToken: get(window.__DATA__, 'secretkey', ''),
        updateCsrfEnabled: true,
        endpoint: '/.gateway',
        axiosConfig: {
            xsrfCookieName: 'CSRF-TOKEN',
            xsrfHeaderName: 'X-CSRF-Token',
            responseType: responseType,
            timeout: timeout,
        },
        handleRequestError: (errorResponse: unknown) => {
            const error = parseError(errorResponse);

            if (error.code === 'SERVICE_IS_READONLY') {
                toaster.createToast({
                    name: 'service-is-readonly',
                    type: 'error',
                    autoHiding: 15000,
                    title: i18n('service-is-readonly-title'),
                });
            }

            throw error;
        },
    });
};

const sdk = sdkFactoryTemplate();

const sdkBinary = sdkFactoryTemplate('arraybuffer', 10000);

if (window.__DATA__.collabOrgId) {
    sdk.setDefaultHeader({
        name: Header.xCollabOrgId,
        value: window.__DATA__.collabOrgId,
    });
    sdkBinary.setDefaultHeader({
        name: Header.xCollabOrgId,
        value: window.__DATA__.collabOrgId,
    });
}
// Передаем и collabOrgId и orgId
// это надо для wfaas, потому что он ходит в трекер, которые умеет только в orgIds
if (window.__DATA__.orgId) {
    sdk.setDefaultHeader({
        // gateway проксирует в бэкенд
        name: 'x-org-id',
        value: window.__DATA__.orgId,
    });
    sdkBinary.setDefaultHeader({
        // gateway проксирует в бэкенд
        name: 'x-org-id',
        value: window.__DATA__.orgId,
    });
}

const parseError = (errorResponse: unknown): GatewayError => {
    const errorData = get(errorResponse, 'data');

    if (!errorData) {
        return {
            status: 500,
            code: 'SDK_REQUEST_ERROR',
            message: 'SDK request error',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            details: errorResponse as any,
        };
    }

    if (typeof errorData === 'string') {
        return {
            status: get(errorResponse, 'status'),
            code: 'SDK_REQUEST_ERROR',
            message: 'SDK request error',
            details: {
                title: get(errorResponse, 'status'),
                description: get(errorResponse, 'statusText'),
            },
        };
    }

    return {
        status: get(errorData, 'status', 500),
        code: get(errorData, 'code', 'SDK_REQUEST_ERROR'),
        message: get(errorData, 'message', 'SDK request error'),
        details: get(errorData, 'details'),
        debug: get(errorData, 'debug'),
    };
};

sdk.setLang(lang);

export {sdk, sdkBinary};
